import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { PropTypes } from 'prop-types';

export default function FrontComparisonTable({ data, title, header }) {
  const renderStarter = rowData => {
    if (rowData.starter) {
      if (typeof rowData.starter === 'string') {
        return <div className="p-text-center">{rowData.starter} </div>;
      }
      return (
        <div className="tik">
          <i className="pi pi-check" />
        </div>
      );
    }

    return null;
  };

  const renderProfessional = rowData => {
    if (rowData.professional) {
      if (typeof rowData.professional === 'string') {
        return <div className="p-text-center">{rowData.professional} </div>;
      }
      return (
        <div className="tik">
          <i className="pi pi-check" />
        </div>
      );
    }
    return null;
  };

  const renderEnterprise = rowData => {
    if (rowData.enterprise) {
      if (typeof rowData.enterprise === 'string') {
        return <div className="p-text-center">{rowData.enterprise} </div>;
      }
      return (
        <div className="tik">
          <i className="pi pi-check" />
        </div>
      );
    }
    return null;
  };

  return (
    <DataTable value={data} header={<div className="table-header">{title} </div>} responsiveLayout="scroll">
      <Column field="category" className=" col-3" header={header} />
      <Column field="STARTER" className=" col-2  p-text-center" body={renderStarter} />
      <Column field="PROFESSIONAL" className=" col-2  p-text-center" body={renderProfessional} />
      <Column field="ENTERPRISE" className=" col-2 p-text-center" body={renderEnterprise} />
    </DataTable>
  );
}

FrontComparisonTable.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string,
  header: PropTypes.string,
};

FrontComparisonTable.defaultProps = {
  title: null,
  header: null,
};
